var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "undo-outfit",
      class: { active: _vm.showUndo },
      on: { click: _vm.undoSwipe }
    },
    [_vm._v("\n    Undo Reject\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-175e26d4", { render: render, staticRenderFns: staticRenderFns })
  }
}